import Widget from "../../../lib/ui/Widget";
import { C } from "../../../lib/ui/constructors";
import { Observable, observe } from "../../../lib/reactive";
var spacer = C.spacer;
var observe_combined = Observable.observe_combined;
export class ControlHeader extends Widget {
    constructor(name, close_handler = null) {
        super(c("<div class='ctr-map-control-header'></div>"));
        this.name = observe(name);
        this.close_handler = observe(close_handler);
        observe_combined({ name: this.name, close_handle: this.close_handler }).subscribe(({ name, close_handle }) => {
            this.empty();
            this
                .append(c().text(name))
                .append(spacer().css("min-width", "20px"));
            if (close_handle) {
                this.append(c("<div class='ctr-map-control-header-close'>&times;</div>")
                    .tooltip("Close")
                    .tapRaw(r => r.on("click", () => close_handle())));
            }
        }, true);
    }
}
export default class ControlWithHeader extends Widget {
    constructor(name, close_handler = null) {
        super();
        this.header = new ControlHeader(name, close_handler).appendTo(this);
        this.body = c("<div class='ctr-map-control-body'></div>").appendTo(this);
    }
    setContent(content) {
        this.body.empty().append(content);
        return this;
    }
}
